import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";

const CountryDetailsList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteOperation } = useHttp();
  const { sendRequest: getCountryData } = useHttp();


    const { sendRequest: getcountries } = useHttp();

  const getcountriesDetail = () => {
    getcountries(
      {
        url: `/api/countries/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);        
        }
      }
    );
  };

  useEffect(() => {
    getcountriesDetail();
  }, [getcountries]);


 
  const handleDelete = (e, countryId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this country?",
      onOk() {
        deleteOperation(
          {
            url: `/api/countries/`,
            method: "DELETE",
            body: { countryId },
          },
          (data) => {
            if (data.success) toast.success(data.success);
            if (data.error) toast.error(data.error);
            getcountriesDetail();
          },
          (error) => {
            toast.error(error);
          }
        );
      },
    });
  };

  const handleSearch = (e) => {
    const filterText = e.target.value.trim().toLowerCase();
    const filterData = allData.filter(
      (item) =>
        item.countryName.toLowerCase().includes(filterText) ||
        item.countryCode.toLowerCase().includes(filterText)
    );
    setData(filterData);
  };
return (
  <div className="content-wrapper">
    
    <div className="row mx-2 align-items-center">
      <div className="col-6">
        <label className="card-title my-3">Country Detail</label>
      </div>
      <div className="col-6 text-right">
        <button
          type="button"
          className="btn btn-primary my-2"
          onClick={() => {
            addForm(true);
            props.update(false);
          }}
        >
          Add Country
        </button>
      </div>
    </div>

    
    <div className="row mx-2">
      <div className="col-12 text-right">
        <input
          type="text"
          className="form-control d-inline-block"
          style={{ width: "250px" }}
          placeholder="Search..."
          onKeyUp={handleSearch}
        />
      </div>
    </div>

    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Country Name</th>
                      <th>Country Code</th>
                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((x, i) => (
                        <tr key={i}>
                          <td>{x.countryName}</td>
                          <td>{x.countryCode}</td>
                          <td>
                            <button
                              className="btn"
                              onClick={() => {
                                props.update(x);
                                props.addForm(true);
                              }}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                          </td>
                          <td>
                            <button
                              className="btn"
                              onClick={(e) => handleDelete(e, x.countryId)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);


};

export default CountryDetailsList;
